import { Component, OnInit ,ElementRef, ViewChild} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Activities } from 'src/interfaces/activities';
import { AppservicesService } from '../services/appservices.service';
import {FormBuilder,FormControl,FormGroup,Validators } from '@angular/forms';
import {Company } from 'src/interfaces/company';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent implements OnInit {

  

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  
  activities:Activities[]=[];
  showgoodname:boolean=false;
  showbadname:boolean=false;
  newcompany:Company;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl('');
  filteredFruits: Observable<string[]>;
  fruits: string[] = ['Lemon'];
  allFruits: string[] = ['Apple', 'Lemon', 'Lime', 'Orange', 'Strawberry'];


  constructor(public formbuilder:FormBuilder,private appserv:AppservicesService, private modal:ModalController)
     {
      this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
        startWith(null),
        map((fruit: string | null) => (fruit ? this._filter(fruit) : this.allFruits.slice())),
      )
     }

  form = this.formbuilder.group({
    name:['', [Validators.required]],
    description: ['', [Validators.required]],
    types:[[], [Validators.required]]
  });

  ngOnInit() {
    this.activities=this.appserv.getactivities();
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.fruits.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.fruits.push(event.option.viewValue);
    this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allFruits.filter(fruit => fruit.toLowerCase().includes(filterValue));
  }

  async closemodal(){
    this.modal.dismiss();
  }

  async createcompany(){

    if(this.form.get('name').value){

      const companies=this.appserv.companyiesdata().filter(c=>c.name.toLocaleLowerCase()==this.form.get('name').value.toLocaleLowerCase());

      if(companies.length>0){
        this.showbadname=true;
        this.appserv.presentToast('ce nom existe deja','warning');
      }else{
        this.newcompany=this.form.value;
        this.showgoodname=true;
        this.appserv.presentToast('Entreprise créée avec succès.','success');
        this.form.reset();
        this.appserv.closemodal();
      }
    }else{
      this.appserv.presentToast('Veuillez completer le nom svp.','danger');
    }
  }
}
